import React from 'react';
import * as dates from "@simplybenefits/sb-dates";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { SearchBar, Theme } from '@simplybenefits/sb-ui-library';
import loadingGif from '../../../../assets/loading.gif';

/**
 * Sets alternating background colours
 * @param {*} index 
 * @returns 
 */
const getRowBackgroundColor = (index) => index % 2 === 0 ? "#FFFFFF" : Theme.colors.backgroundGrey;

/**
 * 
 * @param {*} data
 * @param {*} handleScroll 
 * @param {*} currentSearchTerm 
 * @param {*} search 
 * @param {*} searching 
 * @returns 
 */
const ProvidersTable = ({ data, handleScroll, currentSearchTerm, search, searching }) => {
    const styles = {
        tableContainer: {
            maxHeight: '60vh',
            border: `1px solid ${ Theme.colors.lightGrey }`, 
            overflowY: 'auto', 
            borderRadius: '10px'
        },
        payeesHeaderRow: {
            fontSize: '10px',
            fontFamily: Theme.fonts.type.heading,
            border: `1px solid ${ Theme.colors.lightGrey }`,
            backgroundColor: Theme.colors.backgroundGrey,
            boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.16)',
            padding: '8px',
            lineHeight: '1.25',
            height: '40px'
        },
        payeesRow: {
            fontSize: '12px',
            fontFamily: Theme.fonts.type.medium,
            border: `1px solid ${ Theme.colors.lightGrey }`,
            padding: '8px'
        },
        noWrapCell: {
            whiteSpace: 'nowrap'
        },
        searchBar: {
            flex: 1
        },
        searchWrapper: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            margin: "25px 0px 30px 0px"
        },
        hoverRow: {
            '&:hover': {
                backgroundColor: Theme.colors.lightBlue
            } 
        },
        loaderContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '60vh',
            borderRadius: '10px',
            backgroundColor: 'white'
        }
    };

    return (
        <>
            <div style={styles.searchWrapper}>
                <SearchBar
                    value={currentSearchTerm}
                    search={(e) => search(e)}
                    customStyle={styles.searchBar}
                /> 
            </div>

            {
                searching ?
                    <div style={styles.loaderContainer}>
                        <img src={ loadingGif } alt="loading..." />
                    </div>
                    :    
                    <TableContainer onScroll={handleScroll} sx={styles.tableContainer} >
                        <Table stickyHeader >
                            <TableHead>
                                <TableRow>
                                    <TableCell style={styles.payeesHeaderRow}>First Name</TableCell>
                                    <TableCell style={styles.payeesHeaderRow}>Last Name</TableCell>
                                    <TableCell style={styles.payeesHeaderRow}>cdaID</TableCell>
                                    <TableCell style={styles.payeesHeaderRow}>cdaUin</TableCell>
                                    <TableCell style={styles.payeesHeaderRow}>providerType</TableCell>
                                    <TableCell style={styles.payeesHeaderRow}>paymentType</TableCell>
                                    <TableCell style={{ ...styles.payeesHeaderRow, ...styles.noWrapCell }}>Office Number</TableCell>
                                    <TableCell style={styles.payeesHeaderRow}>Email</TableCell>
                                    <TableCell style={styles.payeesHeaderRow}>Phone</TableCell>
                                    <TableCell style={styles.payeesHeaderRow }>Address</TableCell>
                                    <TableCell style={styles.payeesHeaderRow }>City</TableCell>
                                    <TableCell style={styles.payeesHeaderRow}>Province</TableCell>
                                    <TableCell style={{ ...styles.payeesHeaderRow, ...styles.noWrapCell }}>Postal Code</TableCell>
                                    <TableCell style={{ ...styles.payeesHeaderRow, ...styles.noWrapCell }}>Date Added</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody >
                                {
                                    data.map((payee, index) => (
                                        <TableRow key={index} sx={{ backgroundColor: getRowBackgroundColor(index), ...styles.hoverRow }}>
                                            <TableCell style={ styles.payeesRow }>{payee.firstname}</TableCell>
                                            <TableCell style={styles.payeesRow }>{payee.lastname}</TableCell>
                                            <TableCell style={styles.payeesRow}>{payee.cdaID}</TableCell>
                                            <TableCell style={styles.payeesRow}>{payee.cdaUin}</TableCell>
                                            <TableCell style={styles.payeesRow}>{payee.providerType}</TableCell>
                                            <TableCell style={styles.payeesRow}>{payee.paymentType}</TableCell>
                                            <TableCell style={styles.payeesRow}>{payee.officeNum}</TableCell>
                                            <TableCell style={{ ...styles.payeesRow, ...styles.noWrapCell }}>{payee.email}</TableCell>
                                            <TableCell style={{ ...styles.payeesRow, ...styles.noWrapCell }}>{payee.phone}</TableCell>
                                            <TableCell style={styles.payeesRow }>{payee.address}</TableCell>
                                            <TableCell style={styles.payeesRow}>{payee.city}</TableCell>
                                            <TableCell style={styles.payeesRow}>{payee.province}</TableCell>
                                            <TableCell style={{ ...styles.payeesRow, ...styles.noWrapCell }}>{payee.postalCode}</TableCell>
                                            <TableCell style={{ ...styles.payeesRow, ...styles.noWrapCell }}>{dates.formatDateForDisplay(payee.dateAdded, 'YYYY-MM-DD HH:mm:ss')}</TableCell>
                                        </TableRow>
                                    ))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
            }
        </>
    );
};

export default ProvidersTable;